<a [routerLink]="topicLink" class="impact-item-topic" [ngClass]="{'no-topic' : !impactTopic}">
  <span>{{impactTopic}}</span>
</a>
<a href="{{ impact.link }}">
  <img class="impact-item-image" src="{{ impact.image }}">
</a>
<div class="impact-item-content">
  <div class="impact-item-title">{{ impact.title }}</div>
  <div class="impact-item-description">{{ impact.content }}</div>
  <a *ngIf="showLearnMore" href="{{ impact.link }}">
    <div class="impact-item-learn-more"><img src="/assets/learn-more.svg">Learn More</div>
  </a>
  <div class="impact-item-bottom-row">
    <div class="impact-item-date">{{ impact.date | date: 'mediumDate' }}</div>
  </div>
</div>
